export default __webpack_public_path__ + "static/media/shape01.5dba3e70.png";